/** Estado de filtros/paginação da listagem de Idiomas do país. */
export interface CountryLangFilters {
  /** Texto de busca aplicado (client-side, por idioma, cultura ou nome). */
  readonly search: string;
  /** Página atual (1-indexed) da paginação client-side. */
  readonly page: number;
}

/** Estado inicial (sem busca, primeira página). */
export const INITIAL_COUNTRY_LANG_FILTERS: CountryLangFilters = {
  search: '',
  page: 1,
};
